<script>
    import { Delete, ShowEye } from '../Icons/custom'
    export let filename = 'UNKNOW FILE'
    import PdfIcon from '../../../assets/pictures/g07-pdf-document.svg'
    import Typography from './Typography.svelte'
    export let deleteable = true
    export let preview = false
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    export let progress = 0.25
    function onDelete() {
        dispatch('delete')
    }
    function onPreview() {
        dispatch('preview')
    }
</script>

<div class="item">
    <img alt="" height="100%" width="auto" src={PdfIcon} />
    <span class="container">
        <Typography type="legend" color="grey-800" style="margin: 0"
            >{filename}</Typography
        >
        <span class="bar">
            <span class="loadedbar" style={`width: ${progress * 100}%`}></span>
        </span>
    </span>
    <span style="display:flex;gap: 15px">
        {#if preview}
            <i on:click={onPreview}
                ><ShowEye color={deleteable ? '#C5281C' : '#6F7072'} /></i
            >
        {/if}
        <i on:click={onDelete}
            ><Delete color={deleteable ? '#C5281C' : '#6F7072'} /></i
        >
    </span>
</div>

<style>
    .item {
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* background: rgba(0,0,0,0.05); */
    }
    .item i {
        align-self: flex-end;
        cursor: pointer;
    }
    .bar {
        background: rgba(0, 0, 0, 0.08);
        width: 100%;
    }
    .bar,
    .loadedbar {
        height: 10px;
        margin: 0;
        padding: 0;
        position: relative;
        border-radius: 5px;
    }
    .loadedbar {
        display: block;
        background: var(--color-brand-primary-01);
        transition: all 0.25s ease-in-out;
    }
    .container {
        position: relative;
        display: flex;
        gap: 8px;
        flex-direction: column;
        justify-content: space-between;
        width: 62.5%;
    }
</style>
